import documents from "../services/documents";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        document: {
            uuid: null,
            name: "",
            notes: "",
            description: "",
            no_of_uploads: 1
        },
        loading: false,
        errors: null
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        setDocument(state, document) {
            state.document = document;
        }
    },
    actions: {
        async viewDocument({ commit }) {
            commit("loading");
            try {
                let response = await documents.viewDocument();

                await commit("setDocument", response.data);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async createDocument({ commit }, param) {
            commit("loading");
            try {
                let response = await documents.createDocument(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot create new document.");
                commit("errors", errors);
                console.log(errors);
                commit("loading", false);
            }
        },
        async updateDocument({ commit }, param) {
            commit("loading");
            try {
                let response = await documents.updateDocument(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update document.");
                commit("errors", errors);
                console.log(errors);
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        }
    }
};
